export const lottieProps = {
    loop: false,
    forwardSpeed: 1,
    backwardSpeed: 1,
    playIfVisible: false,
};
